import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'CONTROLE_PATIO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function initForm(registro = {}) {
    return [
        initialize('controlePatioForm', registro)
    ];
}

export function setFiltro(filtro = {}) {
    return {
        type: 'CONTROLE_PATIO_FILTRO',
        payload: {
			filtro: filtro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'CONTROLE_PATIO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getLista(aguardando) {
	return (dispatch, getState) => {
	
		if (getState().controlePatio.modoTela == 'lista' && aguardando) {
			dispatch(setAguardando(true));
		}

    	axios.get(`${consts.API_URL}/controlePatio?padrao=true
			&id_rumo=${getState().controlePatio.filtro.id_rumo}
			&id_atraso=${getState().controlePatio.filtro.id_atraso}
			&data_previsao_chegada=${getState().controlePatio.filtro.data_previsao_chegada}
			&data_previsao_saida=${getState().controlePatio.filtro.data_previsao_saida}
			${getState().controlePatio.filtro.com_previsao_saida ? '&com_previsao_saida=true' : ''}
			${getState().controlePatio.filtro.sem_previsao_saida ? '&sem_previsao_saida=true' : ''}
			&ignoraShippingPassouMatriz=true
			&apenasAbertos=true
		`).then(resp => {
			dispatch({
		        type: 'CONTROLE_PATIO_LISTADO',
		        payload: {
					data: resp.data.filter(item => {
						//Filtra impressão
						if (getState().controlePatio.filtro.impresso && getState().controlePatio.filtro.nao_impresso) {
							return true;
						} else if (getState().controlePatio.filtro.impresso) {
							return (item.id_usuarios_impressao || []).includes(getState().auth.usuario.id);
						} else if (getState().controlePatio.filtro.nao_impresso) { 
							return !(item.id_usuarios_impressao || []).includes(getState().auth.usuario.id);
						}

						return false;
					})
				}
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function getListaHistorico(aguardando) {
	return (dispatch, getState) => {
	
		if (aguardando) {
			dispatch(setAguardando(true));
		}

    	axios.get(`${consts.API_URL}/controlePatio?finalizado=true
			&id_rumo=${getState().controlePatio.filtro.id_rumo}
			&id_atraso=${getState().controlePatio.filtro.id_atraso}
		`).then(resp => {
			dispatch({
		        type: 'CONTROLE_PATIO_HISTORICO_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function getListaExecucao() {
	return (dispatch, getState) => {

    	axios.get(`${consts.API_URL}/controlePatioFichaSetor?noPatio=true`).then(resp => {
			dispatch({
		        type: 'CONTROLE_PATIO_EXECUCAO_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaPortaria() {
	return (dispatch, getState) => {

    	axios.get(`${consts.API_URL}/controlePatio?portaria=true`).then(resp => {
			dispatch({
		        type: 'CONTROLE_PATIO_PORTARIA_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaLogs(idControlePatio) {
	return (dispatch, getState) => {

    	axios.get(`${consts.API_URL}/controlePatio/listarLog?id_controle_patio=${idControlePatio}`).then(resp => {			
			dispatch({
		        type: 'CONTROLE_PATIO_LOG_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function salvarEntrada(registro) {

	return async (dispatch, getState) => {
		if (!registro.registrosEntradaConfirmados) {
			axios.put(`${consts.API_URL}/controlePatio/confirmarPlacas`, {
				...registro,
				datahora_entrada: null,
				odometro_entrada: FormatUtils.formatarValorBanco(registro.odometro_entrada, 0),
                odometro_saida: FormatUtils.formatarValorBanco(registro.odometro_saida, 0),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Registros confirmados');
				dispatch(initForm({
					...registro,
					id_ficha_motorista: resp.data.id_ficha_motorista,
					id_motorista: resp.data.id_motorista,
					nome_motorista: resp.data.nome_motorista,
					id_ficha_cavalo: resp.data.id_ficha_cavalo,
                    cavalo: resp.data.cavalo,
					id_ficha_carreta1: resp.data.id_ficha_carreta1,
                    carreta1: resp.data.carreta1,
					id_ficha_carreta2: resp.data.id_ficha_carreta2,
                    carreta2: resp.data.carreta2,
					registrosEntradaConfirmados: true,
					datahora_previsao_saida: resp.data.datahora_previsao_saida,
					listaPendencias: resp.data.listaPendencias || []
				}));
				dispatch(getLista());
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/controlePatio`, {
				...registro,
				id_status: registro.assinatura_motorista_entrada ? 2 : 1, //2- No Pátio
				id_usuario_entrada: getState().auth.usuario.id,
				montarFichas: true,
				id_ficha_cavalo_entrada: registro.id_ficha_cavalo,
				id_ficha_carreta1_entrada: registro.id_ficha_carreta1,
				id_ficha_carreta2_entrada: registro.id_ficha_carreta2,
				id_ficha_motorista_entrada: registro.id_ficha_motorista,
				odometro_entrada: FormatUtils.formatarValorBanco(registro.odometro_entrada, 0),
                odometro_saida: FormatUtils.formatarValorBanco(registro.odometro_saida, 0),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
	};
}

export function alterarComposicao(registro) {
	return async (dispatch, getState) => {
		axios.put(`${consts.API_URL}/controlePatio/alterarComposicao`, {
			...registro,
			odometro_entrada: FormatUtils.formatarValorBanco(registro.odometro_entrada, 0),
            odometro_saida: FormatUtils.formatarValorBanco(registro.odometro_saida, 0),
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			axios.get(`${consts.API_URL}/controlePatio`).then(resp => {
				const controlePatio = resp.data.filter(item => item.id == registro.id)[0];

				dispatch(initForm({
					...controlePatio,
					cavalo_base: controlePatio.cavalo,
					carreta1_base: controlePatio.carreta1,
					carreta2_base: controlePatio.carreta2,
					id_motorista_base: controlePatio.id_motorista
				}));
		    }).catch(e => {
				setErroAPI(e);
			});
		}).catch(e => {
			setErroAPI(e);
		});
	};
}

export function salvarSaida(registro) {
	return async (dispatch, getState) => {
		axios.put(`${consts.API_URL}/controlePatio`, {
			...registro,
			id_status: 4, //Saída Realizada
			datahora_saida: DateFormat.getDataHoraAtual(),
			id_usuario_saida: getState().auth.usuario.id, 
			id_ficha_cavalo_saida: registro.id_ficha_cavalo,
			id_ficha_carreta1_saida: registro.id_ficha_carreta1,
			id_ficha_motorista_saida: registro.id_ficha_carreta2,
			id_ficha_motorista_entrada: registro.id_ficha_motorista,
			odometro_entrada: FormatUtils.formatarValorBanco(registro.odometro_entrada, 0),
            odometro_saida: FormatUtils.formatarValorBanco(registro.odometro_saida, 0),
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
	};
}

export function salvar(registro) {
	return async (dispatch, getState) => {
		if (!registro.id) {
			await axios.post(`${consts.API_URL}/controlePatio`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/controlePatio`, {
				...registro,
				odometro_entrada: FormatUtils.formatarValorBanco(registro.odometro_entrada, 0),
                odometro_saida: FormatUtils.formatarValorBanco(registro.odometro_saida, 0),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
	};
}

export function salvarOrdemServicoFicha(registro) {

	return async (dispatch, getState) => {
		await axios.put(`${consts.API_URL}/controlePatioFicha/ordemServico`, {
			...registro,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
		}).catch(e => {
			setErroAPI(e);
		});
	};
}

export function setModoTelaChecklist(modo, registro = {}) {
    return {
        type: 'CONTROLE_PATIO_MODO_TELA_CHECKLIST',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function initFormChecklist(registro = {}) {
    return [
        initialize('controlePatioFormChecklist', registro)
    ];
}

export function inicializarChecklist(registro = {}) {

	return async (dispatch, getState) => {

		dispatch(setAguardando(true));

		let retorno = {};
		await axios.get(`${consts.API_URL}/controlePatio/dadosChecklist?id_controle_patio=${registro.id}`).then(resp => {
			retorno = resp.data;
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});

		const getResposta = (idPergunta) => {

			switch (idPergunta) {
				case 1: //Conhecimento Internacional (CRT)
					return retorno.crt;

				case 2: //Conhecimento Nacional (CTE)
					return retorno.cte;

				case 3: //Nota Fiscal
					return retorno.nota_fiscal;

				case 4: //CRLV
					return '';

				case 5: //Cert. Ruído
					return DateFormat.formatarDataSqlParaTela(retorno.data_ruido_cavalo);

				case 6: //Cert. Opacidade
					return DateFormat.formatarDataSqlParaTela(retorno.data_opacidade_cavalo);

				case 7: //Ver. Tec. Cavalo
					return DateFormat.formatarDataSqlParaTela(retorno.data_revisao_tecnica_cavalo);

				case 8: //Ver. Tec. Carreta 1
					return DateFormat.formatarDataSqlParaTela(retorno.data_revisao_tecnica_carreta1);

				case 9: //Ver. Tec. Carreta 2
					return DateFormat.formatarDataSqlParaTela(retorno.data_revisao_tecnica_carreta2);

				case 10: //Cert. Crono tacógrafo
					return '';

				case 11: //Ibama
					return '';

				case 12: //Idoneidade
					return '';

				case 13: //LETPP
					return '';

				case 14: //Licença Exército
					return '';

				case 15: //Licença P.F.
					return '';

				case 16: //Permisso Argentino
					return '';

				case 17: //Permisso Chile
					return '';

				case 18: //Permisso Uruguai
					return '';

				case 19: //Permisso Paraguai
					return '';

				case 20: //Certificado Seguro Cargas
					return '';

				case 21: //Certificado Seguro Internacional
					return '';

				case 22: //Fepam
					return '';

				case 23: //AET
					return '';

					
				default:
					return '';
			}
		}

		dispatch(initFormChecklist({
			...registro,
			listaChecklist: getState().controlePatio.listaChecklist.map((checklist, i) => ({
				id_controle_patio: registro.id,
				id_pergunta: checklist.id,
				nome_pergunta: checklist.nome,
				editavel: checklist.editavel,
				id_tipo: checklist.id_tipo,
				ordem: i + 1,
				id_resposta: 2,
				resposta: getResposta(checklist.id),
				observacao: '',
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}))
		}));

		dispatch(setModoTelaChecklist('checklist', {
			...registro
		}));

	}
}


export function salvarChecklist(registro) {	
	return async (dispatch, getState) => {
		axios.put(`${consts.API_URL}/controlePatio/checklist`, {
			...registro,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista(true));
			dispatch(getListaChecklist());
			dispatch(setModoTelaChecklist('lista'));
			if (registro.idOrigemControlePatio) {
				dispatch(voltarControlePatio(registro.idOrigemControlePatio));
			}
		}).catch(e => {
			setErroAPI(e);
		});
	};
}

export function voltarControlePatio(idRegistro) {	
	return async (dispatch, getState) => {
		
		axios.get(`${consts.API_URL}/controlePatio?id=${idRegistro}`).then(resp => {
			window.location = `/#controlePatio`;

			const registro = resp.data[0];

			if (registro) {
				setTimeout(() => {
					if (registro.id_status == 1) { //Aguardando Entrada
						dispatch(initForm({
							...registro,
							datahora_entrada: DateFormat.getDataHoraAtual()
						}));
						dispatch(setModoTela('entrada', {
							...registro
						}));
						dispatch(getListaLogs(registro.id));
					} else if (registro.id_status == 2) { //No Pátio
						dispatch(initForm({
							...registro,
							cavalo_base: registro.cavalo,
							carreta1_base: registro.carreta1,
							carreta2_base: registro.carreta2,
							id_motorista_base: registro.id_motorista
						}));
						dispatch(setModoTela('saida', {
							...registro
						}));
						dispatch(getListaLogs(registro.id));
					} else if (registro.id_status == 3) { //Aguardando Saída
						dispatch(initForm({
							...registro,
							cavalo_base: registro.cavalo,
							carreta1_base: registro.carreta1,
							carreta2_base: registro.carreta2,
							id_motorista_base: registro.id_motorista
						}));
						dispatch(setModoTela('saida', {
							...registro
						}));
						dispatch(getListaLogs(registro.id));
					}
				}, 200);
			}
		}).catch(e => {
			setErroAPI(e);
		});
	};
}

export function salvarPortaria(registro) {
	return async (dispatch, getState) => {
		axios.put(`${consts.API_URL}/controlePatio`, {
			...registro,
			datahora_saida_portaria: DateFormat.getDataHoraAtual(),
			id_usuario_saida_portaria: getState().auth.usuario.id,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(getListaPortaria());
		}).catch(e => {
			setErroAPI(e);
		});
	};
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/controlePatio?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function salvarExecucao(registro) {
	return async (dispatch, getState) => {
		await axios.put(`${consts.API_URL}/controlePatioFichaSetor`, {
			...registro,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getListaExecucao());
			dispatch(getLista());
		}).catch(e => {
			setErroAPI(e);
		});
	};
}

export function salvarItemManutencao(registro) {
	return async (dispatch, getState) => {
		await axios.put(`${consts.API_URL}/controlePatioFichaManutencao`, {
			...registro,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getListaExecucao());
			dispatch(getLista());
		}).catch(e => {
			setErroAPI(e);
		});
	};
}

export function getListaMotorista() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/motorista/listarSelect?contrato_ativo=true`)
		.then(resp => {			
			dispatch({
				type: 'CONTROLE_PATIO_MOTORISTA_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaPlaca() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/controlePatio/listarPlacas`)
		.then(resp => {			
			dispatch({
				type: 'CONTROLE_PATIO_PLACA_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaChecklist() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/controlePatioChecklist`)
		.then(resp => {			
			dispatch({
				type: 'CONTROLE_PATIO_CHECKLIST_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaManutencaoSugestoes() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/controlePatioFichaManutencao/sugestoes`)
		.then(resp => {			
			dispatch({
				type: 'CONTROLE_PATIO_MANUTENCAO_SUGESTOES_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function gerarPdfFicha(registros) {

	return (dispatch, getState) => {
		
		dispatch(setAguardando(true));

		axios.post(`${consts.API_ETIQUETA_URL}/controlePatio/gerarPdfFicha`, {
            registros: registros.map(registro => ({
				...registro,
				datahora_entrada: DateFormat.formatarDataHoraSqlParaTela(registro.datahora_entrada),
				datahora_previsao_saida: DateFormat.formatarDataHoraSqlParaTela(registro.datahora_previsao_saida),
				cpf_motorista_entrada: FormatUtils.formatarCPF(registro.cpf_motorista_entrada),
				datahora_saida: DateFormat.formatarDataHoraSqlParaTela(registro.datahora_saida),
				cpf_motorista_saida: FormatUtils.formatarCPF(registro.cpf_motorista_saida),
				cpf_motorista: FormatUtils.formatarCPF(registro.cpf_motorista),
				fichas_setores: (registro.fichas_setores || []).map(ficha => {

					let cor = null;
					if (ficha.quantidade == ficha.executadas) {
						cor = '#087d00';
					} else if (ficha.obrigatoria) {
						cor = '#949191';
					} else {
						cor = '#949191';
					}

					return {
						id_setor: ficha.id_setor,
						icone: ficha.icone,
						cor: cor,
						nome: ficha.nome,
						status: ficha.quantidade == ficha.executadas ? 'OK' : (`${ficha.executadas} de ${ficha.quantidade}`),
						obrigatoria: ficha.obrigatoria ? 'Obrigatório' : ''
					};
				}),
				id_usuario_impressao: getState().auth.usuario.id
			})),
			datahora_emissao: DateFormat.formatarDataHoraSqlParaTela(DateFormat.getDataHoraAtual())
        }).then(resp => {
			
			const link = document.createElement('a');
			link.href = `data:application/pdf;base64,${resp.data.pdf}`;
			link.download = resp.data.filename;
			link.click();

			dispatch(setAguardando(false));
			dispatch(getLista());
		}).catch(ex => {
			console.log(ex);
			dispatch(setAguardando(false));
		});

	}
}